<!-- Email details like To:- From:- Date:- etc -->

<template>
  <div>
    <v-row class="mt-12 mb-2" no-gutters v-if="!openInModal">
      <v-col class="pa-0">
        <!-- <span>Subject&nbsp;:&nbsp;</span> -->
        <h2>{{ subject }}</h2>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4">
      <v-col>
        <v-row class="mb-2" v-if="!showActionBtnSent" no-gutters>
          <v-col class="pa-0">
            <span>From&nbsp;:&nbsp;</span>
            <span class="description-item">{{ fromEmail }}</span>
          </v-col>
        </v-row>
        <v-row class="mb-2" no-gutters>
          <v-col class="pa-0">
            <span>To&nbsp;:&nbsp;</span>
            <span class="description-item">{{ recipientsList }}</span>
          </v-col>
        </v-row>

        <v-row class="mb-2" v-if="ccEmail" no-gutters>
          <v-col class="pa-0">
            <span>Cc&nbsp;:&nbsp;</span>
            <span class="description-item">{{ ccEmail.join(',') }}</span>
          </v-col>
        </v-row>

        <v-row
          class="mb-2"
          v-if="bccsEmail !== null && showActionBtnSent"
          no-gutters
        >
          <v-col class="pa-0">
            <span>Bcc&nbsp;:&nbsp;</span>
            <span class="description-item">{{ bccsEmail }}</span>
          </v-col>
        </v-row>
        <!-- <v-row class="mb-2" v-if="!showActionBtnSent">
              <v-col class="pa-0">
                <span>Recepient&nbsp;:&nbsp;</span>
                <span>{{recipientsList}}</span>
              </v-col>
            </v-row>-->
        <v-row class="mb-2" align="center" no-gutters v-if="!openInModal">
          <v-col class="pa-0">
            <span>Date&nbsp;:&nbsp;</span>
            <span class="description-item">{{ date }}</span>
          </v-col>
          <v-col class="pa-0 text-right">
            <v-btn
              text
              class="pa-0 font700 h-auto"
              :ripple="false"
              color="#58e2c2"
              v-if="showImageLink"
              :data-test-id="`${dataTestId}__show-images-btn`"
              @click="() => this.$emit('confirmationToEnable')"
            >
              Show images and links
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="2" v-if="openInModal">
        <x-button
          class="w-auto v-btn saveButton"
          buttonText="Add to Saved Items"
          @click="() => addToSaved('modal')"
          color="#58e2c2"
          :data-test-id="`${dataTestId}-modal__add-to-saved-btn`"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EventBus from '@/EventBus';
export default {
  name: 'EmailTemplateArchivesDetail',
  props: [
    'subject',
    'openInModal',
    'showImageLink',
    'showActionBtnSent',
    'fromEmail',
    'recipientsList',
    'ccEmail',
    'bccsEmail',
    'date',
    'emailId',
    'dataTestId'
  ],
  methods: {
    async addToSaved() {
      try {
        await this.$services.project.addArchives(this.$route.params.projectId, {
          archives: [this.emailId],
          archiveType: this.$enums.archiveType.EMAIL
        });
        this.snackbar('success', this.$message.ITEMS_SAVED);
        EventBus.$emit('REFRESH_COLLABORATORS', true);
      } catch (err) {
        this.snackbar('error', this.$message.ERROR);
      }
    }
  }
};
</script>
<style scoped>
.description-item {
  color: #525252;
  font-size: 14px;
}
span {
  font-weight: 600;
}
</style>
